import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { Panel, PeriodToggle } from "@/components/dash/Ui";
import { RankList } from "@/components/dash/RankList";

export const StatsView = ({ s, gran, setGran, showLinks = true }) => (
  <>
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {[["range", "Clicks in range"], ["unique_ips", "Unique IPs in range"], ["today", "Today"], ["all", "All time"]].map(([k, label], i) => (
        <Panel key={k} className="rise" style={{ animationDelay: `${i * 60}ms` }} data-testid={`stat-${k}`}>
          <p className="text-xs text-slate-400 uppercase tracking-wider">{label}</p>
          <p className="font-display text-4xl font-bold mt-3">{s ? s.totals[k] : "–"}</p>
        </Panel>
      ))}
    </div>
    <Panel className="mt-4">
      <div className="flex flex-wrap gap-3 justify-between items-center mb-6">
        <h2 className="font-display text-lg font-semibold">Clicks over time</h2>
        <PeriodToggle value={gran} onChange={setGran} options={["day", "week", "month"]} />
      </div>
      <div className="h-72" data-testid="clicks-chart">
        <ResponsiveContainer>
          <AreaChart data={s?.series || []}>
            <defs>
              <linearGradient id="g" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#10b981" stopOpacity={0.4} />
                <stop offset="100%" stopColor="#10b981" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="#1f2937" vertical={false} />
            <XAxis dataKey="label" stroke="#6b7280" fontSize={11} tickLine={false} axisLine={false}
              tickFormatter={(v) => (gran === "day" ? v.slice(5) : v)} />
            <YAxis stroke="#6b7280" fontSize={11} tickLine={false} axisLine={false} allowDecimals={false} width={30} />
            <Tooltip contentStyle={{ background: "#0f172a", border: "1px solid #1f2937", borderRadius: 12 }} />
            <Area type="monotone" dataKey="clicks" stroke="#10b981" strokeWidth={2.5} fill="url(#g)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Panel>
    <div className={`grid md:grid-cols-2 ${showLinks ? "lg:grid-cols-4" : "lg:grid-cols-3"} gap-4 mt-4`}>
      <RankList title="Countries" items={s?.countries} testid="top-countries" />
      <RankList title="Cities" items={s?.cities} testid="top-cities" />
      <RankList title="Numbers / agents" items={s?.agents} testid="top-agents" />
      {showLinks && <RankList title="Links" items={s?.links} testid="top-links" prefix="/" />}
    </div>
  </>
);
